<div class="content-container margin-bottom">
    <section role="region" aria-label="Efforts controls" class="controls">
        <h2 class="visually-hidden">Efforts controls</h2>
        <div class="left-controls">
            <div class="filters">
                <app-filter-editor [formControl]="filterControl" [chips]="['title', 'key', 'dept']"
                    [flags]="['archived']" label="Filter efforts - search by attribute or type freely to search all."
                    [selectedFilters]="(selectedFilters | async) || []" (filterChange)="filterChange($event)"
                    [chipPossVals]="chipPossVals" [chipHelpers]='chipHelpers' class="filter-editor">
                </app-filter-editor>

                <button mat-stroked-button (click)="selectedFilters.next([])">
                    <mat-icon class="material-symbols-outlined">clear</mat-icon>
                    Clear
                </button>
            </div>
        </div>

        <div class="right-controls">
            @if (canAdd) {
            <button mat-stroked-button (click)="openEditor(null, true)">
                <mat-icon>add</mat-icon>
                Add New Effort
            </button>
            }
        </div>
    </section>
</div>

<section role="region" aria-label="Efforts table entries" class='efforts-table-container'>
    <h2 class="visually-hidden">Efforts table entries</h2>
    <table mat-table [dataSource]="dataSource" class="efforts-table" multiTemplateDataRows matSort
        matSortDirection="asc" matSortActive="title" scope="col">

        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">Effort Title</th>
            <td mat-cell *matCellDef="let effort" (click)="toggleExpand(effort.id)">
                <a href="javascript:void(0)" (click)="openEditor(effort, false)"
                    title="View projects related to this effort." [class.is-archived]="effort.isDeleted">
                    {{ effort.title }}
                </a>
            </td>
        </ng-container>

        <ng-container matColumnDef="projects">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">Projects</th>
            <td mat-cell *matCellDef="let effort">
                <a [routerLink]="['/projects']" [queryParams]="{ 'filter.effort': effort?.key }"
                    title="View projects related to this effort.">{{ effort.projects.length }} project(s)</a>
            </td>
        </ng-container>

                <ng-container matColumnDef="owners">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">Owners</th>
            <td mat-cell *matCellDef="let effort">
                <a [routerLink]="['/users']" [queryParams]="{ 'filter.effort.key': effort?.key }"
                    title="View owners related to this effort.">{{ effort.effortOwners?.length }} owner(s)</a>
            </td>
        </ng-container>

        <ng-container matColumnDef="dept">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">Department</th>
            <td mat-cell *matCellDef="let effort">
                <a [routerLink]="['/departments']" [queryParams]="{ 'filter.key': effort?.principalGroup?.key }"
                    title='View department related to this effort.'>
                    {{ effort?.principalGroup?.name }}
                </a>
            </td>
        </ng-container>

        <ng-container matColumnDef="tools">
            <th mat-header-cell *matHeaderCellDef scope="col">Actions</th>
            <td mat-cell *matCellDef="let effort">
                @if (canModify(effort)) {
                <button mat-icon-button aria-label="Delete Row" (click)="deleteEffort(effort)">
                    <mat-icon>delete</mat-icon>
                </button>
                }
            </td>
        </ng-container>

        <!-- header no results message -->
        <ng-container matColumnDef='no-results'>
            <td mat-header-cell *matHeaderCellDef [attr.colspan]='4' class='whole-row-no-results whole-row-helper'>
                @if (! (isLoading | async)) {
                <div>
                    <p>No efforts found.
                        @if ((selectedFilters | async)?.length) {
                        <button mat-flat-button color="accent" (click)='selectedFilters.next([])'>Clear Filter</button>
                        }
                        @if (canAdd) {
                        <button mat-stroked-button color="primary"
                            (click)="openEditor(null, true)"><mat-icon>add</mat-icon>
                            Add New Effort</button>
                        }
                    </p>
                </div>
                }
            </td>
        </ng-container>

        <!-- Unused Columns -->
        <ng-container matColumnDef="key">
            <th mat-header-cell *matHeaderCellDef scope="col">Key</th>
            <td mat-cell *matCellDef="let effort" (click)="toggleExpand(effort.id)">
                {{ effort.key }}
            </td>
        </ng-container>
        <ng-container matColumnDef="groups">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">Groups</th>
            <td mat-cell *matCellDef="let effort">
                <a [routerLink]="['/departments']" [queryParams]="{ 'filter.effort': effort?.key }"
                    title='View groups related to this effort.'>
                    {{ effort.groupEfforts.length }} Groups
                </a>
            </td>
        </ng-container>
        <ng-container matColumnDef="views">
            <th mat-header-cell *matHeaderCellDef scope="col">Views</th>
            <td mat-cell *matCellDef="let effort" class="effort-views">
                <button mat-icon-button [routerLink]="['/departments']" [queryParams]="{ 'filter.effort': effort?.key }"
                    title="View or edit departments associated with this effort.">
                    <mat-icon class="material-symbols-outlined" style="display: inline;">group_search</mat-icon>
                </button>
            </td>
        </ng-container>
        <ng-container matColumnDef="effort-definition">
            <td mat-cell *matCellDef="let effort" colspan="3">
                <div class="effort-editor">
                    <mat-form-field>
                        <mat-label>Edit Title</mat-label>
                        <input matInput [(ngModel)]="effort.title">
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Tags</mat-label>
                        <mat-chip-grid #chipGrid aria-label="Effort tags">
                            @for (tag of effort.tags; track tag) {
                            <mat-chip>
                                {{ tag }}
                                <!-- <mat-icon matChipRemove>cancel</mat-icon> -->
                            </mat-chip>
                            }
                        </mat-chip-grid>
                        <input name="effortTag" placeholder="Find a tag" #fruitInput [(ngModel)]="currentTag"
                            [matChipInputFor]="chipGrid" [matAutocomplete]="tagAuto"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            (matChipInputTokenEnd)="addTag(effort, $event)" />
                        <mat-autocomplete #tagAuto="matAutocomplete">
                            @for (tag of allTags; track tag) {
                            <mat-option [value]="tag">{{ tag }}</mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Members</mat-label>
                        <mat-select multiple [(ngModel)]="effort.users">
                            @for (member of allMembers; track member) {
                            <mat-option [value]="member">
                                {{ member }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </td>
        </ng-container>
        <!-- /End Unused Columns -->

        <tr mat-header-row *matHeaderRowDef="['title', 'owners', 'projects', 'dept']; sticky: true">
        </tr>
        <tr mat-row *matRowDef="let row; 
            columns: [ 'title', 'owners', 'projects', 'dept'];">
        </tr>
        <tr [hidden]='dataSource.data.length > 0' mat-header-row *matHeaderRowDef="['no-results'];" class="no-results">
        </tr>
    </table>

    <div class="loading-data" [class.showing]="isLoading | async">
        <mat-spinner></mat-spinner>
    </div>
</section>

<section role="region" aria-label="Efforts table pagination" class="bottom-tools">
    <h2 class="visually-hidden">Efforts table pagination</h2>
    <mat-paginator [pageSizeOptions]="[10, 15, 20, 30, 50, 100]" showFirstLastButtons [pageSize]="pageSize"
        [length]="totalEfforts">
    </mat-paginator>
</section>